export default class Animationoff {
  constructor() {
    this.init();
  }

  init() {
    window.addEventListener("DOMContentLoaded", () => {
      this._getUrl();
    });
  }

  _getUrl() {
    var ref = document.referrer;

    var flag = ref.indexOf("character");

    if (flag !== -1) {
      this._setAnimatinonOff();
    }
  }

  _setAnimatinonOff() {
    document.body.classList.add("-rescharacter");
  }
}
